import { PagePath } from 'constants/pagePath';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { create } from 'zustand';

// isCustom=trueの場合はuseCustomLocationNameで設定した名前を用いる
type PageLocationNameMap = { [P in PagePath]: { pageName: string; isCustom?: true } };
const pageLocationNameMap: PageLocationNameMap = {
  [PagePath.Root]: {
    pageName: '',
  },
  [PagePath.Login]: {
    pageName: '',
  },
  [PagePath.AgencyLogin]: {
    pageName: '',
  },
  [PagePath.SendSMS]: {
    pageName: '',
  },
  [PagePath.ReissuePassword]: {
    pageName: '',
  },
  [PagePath.ActivationCode]: {
    pageName: '',
  },
  [PagePath.AccountOpen]: {
    pageName: '口座開設申込フォーム',
    isCustom: true,
  },
  [PagePath.AccountOpenProfileDetails]: {
    pageName: '口座開設申込フォーム本登録回答',
    isCustom: true,
  },
  [PagePath.PersonalAccountOpen]: {
    pageName: '口座開設申込フォーム',
    isCustom: true,
  },
  [PagePath.PersonalAccountOpenProfileDetails]: {
    pageName: '口座開設申込フォーム本登録回答',
    isCustom: true,
  },
  [PagePath.Home]: {
    pageName: 'HOME',
  },
  [PagePath.ProgramList]: {
    pageName: '',
    isCustom: true,
  },
  //[PagePath.LeaseFundProgramList]: {
  //  pageName: '案件一覧（リースファンド）',
  //},
  //[PagePath.DomesticRealEstateItExplanationProgramList]: {
  //  pageName: '案件一覧（国内不動産）',
  //},
  [PagePath.LeaseFundSymbolDetail]: {
    pageName: '',
    isCustom: true,
  },
  [PagePath.DomesticRealEstateItExplanationSymbolDetail]: {
    pageName: '',
    isCustom: true,
  },
  [PagePath.DomesticRealEstateSymbolDetail]: {
    pageName: '',
    isCustom: true,
  },
  [PagePath.OverseasRealEstateSymbolDetail]: {
    pageName: '',
    isCustom: true,
  },
  [PagePath.Position]: {
    pageName: '出資案件一覧',
  },
  [PagePath.RequestHistory]: {
    pageName: '申込履歴',
  },
  [PagePath.IssuanceDocument]: {
    pageName: '交付書面',
    isCustom: true,
  },
  [PagePath.LeaseFundContractProcedure]: {
    pageName: 'ご契約手続き',
    isCustom: true,
  },
  [PagePath.OverseasRealEstateContractProcedure]: {
    pageName: 'ご契約手続き',
    isCustom: true,
  },
  [PagePath.SubUser]: {
    pageName: '利用者登録',
  },
  [PagePath.SubUserAdd]: {
    pageName: '利用者追加',
  },
  [PagePath.CompatibilityCheck]: {
    pageName: '適合性チェック回答入力',
    isCustom: true,
  },
  [PagePath.ConfirmCompatibilityCheck]: {
    pageName: '適合性チェック結果確認',
  },
  [PagePath.Contact]: {
    pageName: 'お問い合わせ',
  },
  [PagePath.Notice]: {
    pageName: 'お知らせ',
  },
  [PagePath.NoticeDetail]: {
    pageName: 'お知らせ詳細',
  },
  [PagePath.AccountInfo]: {
    pageName: 'ご登録内容の照会/変更',
  },
  [PagePath.ChangePassword]: {
    pageName: 'パスワード変更',
  },
  [PagePath.Faq]: {
    pageName: 'FAQ',
  },
  [PagePath.FaqLink]: {
    pageName: 'FAQ',
  },
};

type LocationNameStore = {
  name: string;
  subDescription?: string | null;
  setName: (name: string, subDescription?: string | null) => void;
};

const useLocationNameStore = create<LocationNameStore>((set) => ({
  name: '',
  subDescription: null,
  setName: (name: string, subDescription?: string | null) => set(() => ({ name, subDescription})),
}));

const paths = Object.values(PagePath);
const getMainPathName = (path: string) => {
  const splits = path.split('/');
  return '/' + splits[1] + '/';
};

export const useLocationName = () => {
  const customNameInfo = useLocationNameStore((state) =>  {
    return {
      name: state.name,
      subDescription: state.subDescription
    }}
  );
  const location = useLocation();
  const locationNameFromPath =
    pageLocationNameMap[
      paths.find((path) => getMainPathName(location.pathname).toLowerCase() === path.toLowerCase()) as PagePath
    ];

  // Pathから定義された名前かuseCustomLocationNameで設定された名前を返す
  return {
    name: locationNameFromPath?.isCustom ? customNameInfo.name : locationNameFromPath?.pageName,
    subDescription: customNameInfo.subDescription,
  };
};

export const useCustomLocationName = (name: string, subDescription?: string | null) => {
  const setName = useLocationNameStore((state) => state.setName);

  useEffect(() => {
    setName(name, subDescription);
    return () => {
      setName('');
    };
  }, [name, subDescription]);

  return {
    setName,
  };
};
